/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-06-12T15:54:15.795
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';

import {
	saveRentChannelApplyItem,
	getRentChannelApplyItemCreateInit,
	getRentChannelApplyItemEditInit,
	getRentChannelApplyItemView,
	deleteRentChannelApplyItem
} from '@api/rentmanage/RentChannelApplyItem';

import {
	cloneObj
} from '@/plugins/utils';

import RespCommonDef from '@/plugins/utils/RespCommonDef';

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntityDictionaryAdd: cloneObj(RespCommonDef.CompoundEntityDictionary),
	},

	actions: {
		getRentChannelApplyItemCreateInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				getRentChannelApplyItemCreateInit({})
					.then(async res => {
						state.CompoundEntityDictionaryAdd = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getRentChannelApplyItemEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentChannelApplyItemEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},


		saveRentChannelApplyItem({}, RentChannelApplyItem) {
			return new Promise((resolve, reject) => {
				saveRentChannelApplyItem(RentChannelApplyItem)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getRentChannelApplyItemView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentChannelApplyItemView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteRentChannelApplyItem({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentChannelApplyItem({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		}
	}
};
